import { render, staticRenderFns } from "./PlaceWithPopover.vue?vue&type=template&id=28565a8a&"
import script from "./PlaceWithPopover.vue?vue&type=script&lang=ts&"
export * from "./PlaceWithPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports